/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Cart } from '../../models/cart';

export interface ApiCartGet$Params {
  waitUntilCommitPositionReached?: number;
}

export function apiCartGet(http: HttpClient, rootUrl: string, params?: ApiCartGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Cart>> {
  const rb = new RequestBuilder(rootUrl, apiCartGet.PATH, 'get');
  if (params) {
    rb.query('waitUntilCommitPositionReached', params.waitUntilCommitPositionReached, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Cart>;
    })
  );
}

apiCartGet.PATH = '/api/cart';
